import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import MobiMain from '../views/MobiMain.vue'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login,
    },
    {
      path: '/Mobi/Login',
      name: 'MobiLogin',
      component: Login,
    },
    {
      path: '/Mobi/Main',
      name: 'MobiMain',
      alias: ['/mobileMain'],
      component: MobiMain,
    },
    {
      path: '/Mobi/Credit',
      name: 'MobiCredit',
      component: () => import('../views/MobiCredit.vue'),
    },
    {
      path: '/Mobi/BetDetail',
      name: 'MobiBetDetail',
      component: () => import('../views/MobiBetDetail.vue'),
    },
    {
      path: '/Mobi/Settlement',
      name: 'MobiSettlement',
      component: () => import('../views/MobiSettlement.vue'),
    },
    {
      path: '/Mobi/SettlementCategory',
      name: 'MobiSettlementCategory',
      component: () => import('../views/MobiSettlementCategory.vue'),
    },
    {
      path: '/Mobi/SettlementCategoryBets',
      name: 'MobiSettlementCategoryBets',
      component: () => import('../views/MobiSettlementCategoryBets.vue'),
    },
    {
      path: '/Mobi/Game',
      name: 'MobiGamePlay',
      component: () => import('../views/GamePlay.vue'),
    },
    {
      path: '/Mobi/Canada20',
      name: 'MobiCanada20',
      component: () => import('../views/MobiCanada20.vue'),
    },
    {
      path: '/Mobi/DrawHistory',
      name: 'MobiDrawHistory',
      component: () => import('../views/MobiDrawHistory.vue'),
    },
    {
      path: '/Mobi/PlayRules',
      name: 'MobiPlayRules',
      component: () => import('../views/MobiPlayRules.vue'),
    },
    {
      path: '/Mobi/ChangePassword',
      name: 'MobiChangePassword',
      component: () => import('../views/MobiChangePassword.vue'),
    },
    {
      path: '/Mobi/UserAgreement',
      name: 'MobiUserAgreement',
      component: () => import('../views/MobiUserAgreement.vue'),
    },
  ],
})

router.beforeEach((to, from, next) => {
  try {
    if (localStorage.getItem('mobi_must_change_pwd') === '1') {
      const allow =
        to.name === 'MobiChangePassword' ||
        to.name === 'Login' ||
        to.name === 'MobiLogin'
      if (!allow) {
        const u = (
          (to.query && to.query.user) ||
          localStorage.getItem('mobi_login_name') ||
          ''
        ).toString()
        next({ name: 'MobiChangePassword', query: { user: u, first: '1' } })
        return
      }
    }
  } catch (e) {
    /* ignore */
  }
  try {
    if (localStorage.getItem('mobi_account_frozen') === '1') {
      const frozenAllowed = ['MobiSettlement', 'MobiSettlementCategory', 'MobiSettlementCategoryBets', 'MobiMain', 'MobiCredit', 'MobiBetDetail', 'MobiDrawHistory', 'MobiPlayRules', 'MobiChangePassword', 'MobiUserAgreement', 'Login', 'MobiLogin']
      if (!frozenAllowed.includes(to.name)) {
        next({ name: 'MobiSettlement' })
        return
      }
    }
  } catch (e) {
    /* ignore */
  }
  next()
})

export default router
